module.exports = __webpack_public_path__ + "static/media/Project1_Archetype1.ea1281ab.png";